// tslint:disable
export var NameType;
(function (NameType) {
    // UNKN
    NameType[NameType["UNKN"] = 0] = "UNKN";
    // LGLNM
    NameType[NameType["LGLNM"] = 1] = "LGLNM";
    // MDNNM
    NameType[NameType["MDNNM"] = 2] = "MDNNM";
    // MRDNM
    NameType[NameType["MRDNM"] = 3] = "MRDNM";
    // PRNM
    NameType[NameType["PRNM"] = 4] = "PRNM";
    // DBA
    NameType[NameType["DBA"] = 5] = "DBA";
    // AKA
    NameType[NameType["AKA"] = 6] = "AKA";
    // NKNM
    NameType[NameType["NKNM"] = 7] = "NKNM";
})(NameType || (NameType = {}));
//# sourceMappingURL=NameType.js.map